export function injectBadgeStyles() {
  const STYLE_ID = "form-success-anim-style";
  const existing = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  const css = `
    .success-badge { display: inline-flex; align-items: center; gap: 8px; }
    .success-badge__icon {
      width: 20px; height: 20px; border-radius: 9999px;
      background: #10b981; color: #fff;
      display: inline-flex; align-items: center; justify-content: center;
      animation: badge-pop 160ms ease-out 1;
    }
    .error-badge { display: inline-flex; align-items: center; gap: 8px; }
    .error-badge__icon {
      width: 20px; height: 20px; border-radius: 9999px;
      background: #ef4444; color: #fff;
      display: inline-flex; align-items: center; justify-content: center;
      animation: badge-pop 160ms ease-out 1;
    }
    @keyframes badge-pop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
  `;
  if (existing) {
    existing.innerHTML = css;
  } else {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.innerHTML = css;
    document.head.appendChild(style);
  }
}
